export default {"src":"/_next/static/media/sunnova.da4d0a7a.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};